import React, { useState } from 'react';
import MultiSelect from './componenets/MultiSelect';
import SingleSelect from './componenets/SingleSelect';
import AllSelect from './componenets/AllSelect'

const buttonStyle = {
    backgroundColor: '#00baaa',
    color: '#fff',
    padding: '11px 10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
};

const blurredButtonStyle = {
    backgroundColor: 'gray',
    color: 'white',
    padding: '11px 10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'not-allowed',
};

function RedisClearContainer() {
    const [showSingleKeyComponent, setShowSingleKeyComponent] = useState(null);
    const [ShowAllKeyComponent, setShowAllKeyComponent] = useState(null);

    const handleSingleKeyButtonClick = () => {
        setShowSingleKeyComponent(true);
        setShowAllKeyComponent(false);
    };

    const handleMultiKeyButtonClick = () => {
        setShowSingleKeyComponent(false);
        setShowAllKeyComponent(false);
    };
    const handleAllKeyButtonClick = () => {
        setShowSingleKeyComponent(false);
        setShowAllKeyComponent(true);
    }

    return (
        <div className="container my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1>Redis Developer Console</h1>
            <div>
                <button
                    onClick={handleSingleKeyButtonClick}
                    style={showSingleKeyComponent === true && ShowAllKeyComponent === false ? blurredButtonStyle : buttonStyle}
                >
                    Clear Single Key
                </button>
                <button
                    className='mx-2'
                    onClick={handleMultiKeyButtonClick}
                    style={showSingleKeyComponent === false && ShowAllKeyComponent === false ? blurredButtonStyle : buttonStyle}
                >
                    Clear Multiple Keys
                </button>
                <button
                    onClick={handleAllKeyButtonClick}
                    style={showSingleKeyComponent === false && ShowAllKeyComponent === true ? blurredButtonStyle : buttonStyle}
                >
                    Clear All Keys
                </button>
            </div>
            {showSingleKeyComponent === true && ShowAllKeyComponent === false && <SingleSelect />}
            {showSingleKeyComponent === false && ShowAllKeyComponent === false && <MultiSelect />}
            {showSingleKeyComponent === false && ShowAllKeyComponent === true && <AllSelect />}
        </div>
    );
}

export default RedisClearContainer;
